// extracted by mini-css-extract-plugin
export default {"Container":"skeleton_Container__xSdPI","wrapper":"skeleton_wrapper__Jnm1H"};